import { useQuery } from '@tanstack/react-query';
import apiClient from './apiClient';

const backupLogsKeys = {
  all: ['backupLogs'],
  last: () => [...backupLogsKeys.all, 'last'],
};

export const useLastBackupLog = () => {
  return useQuery({
    queryKey: backupLogsKeys.last(),
    queryFn: async () => {
      const response = await apiClient.get('backup-logs/last');
      return response.data;
    },
    staleTime: 8 * 60 * 60 * 1000,
    gcTime: 8 * 60 * 60 * 1000,
  });
};